import { queryLatestData } from '@/api/realTimeData'

const realTimeData = {
  state: {
    gaugeData: []
  },

  mutations: {
    SET_GAUGE_DATA: (state, data) => {
      state.gaugeData = data
    }
  },

  actions: {
    //
    async queryLatestData({ commit }, params) {
      const response = await queryLatestData(params)
      // return response.data
      // console.log(response.data)
      // commit('SET_BMAP_INFOS', response.data)
      if (response.data != null) {
        commit('SET_GAUGE_DATA', response.data)
      }
    }
  }
}

export default realTimeData
